import React, { useState, useEffect } from "react";
import { ScheduleComponent, ViewDirective, Day, Week, WorkWeek, Month, Agenda, Inject, Resize, DragAndDrop } from '@syncfusion/ej2-react-schedule';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';


import { Header } from '../components';
import { DataSource } from '@syncfusion/ej2/diagrams';

const Calendar = () => {
  const [calendars, setCalendars] = useState([]);
  useEffect(() => {
    const fetchCalendars = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/calendars`, {
          method: "GET",
          headers: {
            "api-key": process.env.REACT_APP_API_KEY,
          },
        });
  
        if (!response.ok) {
          throw new Error("Failed to fetch");
        }
  
        const data = await response.json();
  
        // Reverse the data array
        const reversedData = data.reverse();
  
        // Update the state with reversed data
        setCalendars(reversedData);
      } catch (error) {
        Swal.fire("Error", "Failed to fetch letters. Please try again later.", "error");
      }
    };
  
    fetchCalendars();
  }, []); // Depe
  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="App" title="Calendar" />
      <ScheduleComponent
        height="650px"
        eventSettings={{ dataSource: calendars }}
        selectedDate={new Date(2021, 0, 10)}
      >
        <Inject services={[Day, Week, WorkWeek, Month, Agenda, Resize, DragAndDrop]} />
      </ScheduleComponent>
    </div>
  )
}

export default Calendar;